// extracted by mini-css-extract-plugin
module.exports = {"carouselIndicators":"CarouselIndicators-module__carouselIndicators___3J-2a","active":"CarouselIndicators-module__active___UStmC"};